import { schema } from 'normalizr';
import { SchemaKeys } from 'data/core';
import { taskSchema } from 'data/tasks/schema';
const sprintSchema = new schema.Entity(SchemaKeys.Sprints, {}, {
    idAttribute: 'sprintId'
});
export const projectPhaseSchema = new schema.Entity('projectPhases', {
    tasks: [
        taskSchema
    ],
    sprints: [
        sprintSchema
    ]
}, {
    idAttribute: 'projectPhaseId'
});
// NOTE:: Customising it here since templates uses `spaceList` instead of `spaces`
const spaceSchema = new schema.Entity('spaceList', {
}, {
    idAttribute: (value)=>String(value.spaceId),
    processStrategy: (entity)=>{
        return entity.spaceTabs ? // https://northstar.nitro.run/projects/4895/plan#task_drawer=4895.3960823&task_drawer_tab=conversations
        {
            ...entity,
            private: (entity === null || entity === void 0 ? void 0 : entity.private) === true
        } : {
            ...entity,
            private: (entity === null || entity === void 0 ? void 0 : entity.private) === true,
            spaceTabs: []
        };
    }
});
export const templateSchema = new schema.Entity('template', {
    templateContent: {
        projectPhases: [
            projectPhaseSchema
        ],
        sprints: [
            sprintSchema
        ],
        spaceList: [
            spaceSchema
        ]
    }
}, {
    idAttribute: 'templateId'
});
